<style  lang="scss">
.ant-select-dropdown {
  min-width: 140px !important;
  max-width: 350px !important;
  width: fit-content !important;
}

.custom-all__label {
  div {
    display: none;
  }
}

.month-picker__input {
  .ant-calendar-picker-input {
    border-radius: 10px;
    font-size: 14px;

    .ant-calendar-picker-input {
      margin-top: -8px;
    }
  }
}

.ant-select-selection--multiple {
  max-height: 40px;
}

.ant-select {
  height: 40px;
}

.ant-select-dropdown-menu-item {
  border-bottom: 1px solid #ededed;
}

.ant-select-dropdown-menu-item:last-child {
  border-bottom: none;
}

.ant-select-selection__placeholder {
  font-size: 14px;
}

.ant-select-selection {
  border-radius: 10px !important;
}

.ant-radio-wrapper {
  margin-bottom: 3px;
}

.ant-radio-wrapper {
  margin-right: 0 !important;

  span {
    padding-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper {
  padding: 20px 10px 4px 10px;

  .header {
    text-align: center;
    margin-bottom: 20px;

    h4 {
      font-size: 18px;
      font-weight: 700;
      color: #303c54;
    }
  }

  .select-group__wrapper {
    height: 77px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 5px;
    margin-bottom: 20px;

    .select-group__left {
      display: flex;
      align-items: center;

      .month-picker__wrapper {
        width: 156px;
        margin-left: 8px;
      }

      .time-content {
        font-size: 14px;
      }
    }

    .select-group__right {
      align-items: center;
      display: flex;

      .month-picker__wrapper {
        width: 156px;
        margin-left: 8px;
      }

      .time-content {
        font-size: 14px;
      }
    }
  }

  .chart {
    height: 575px;
  }

  .bottom {
    margin-top: 10px;
    height: 14px;

    img {
      margin-right: 6px;
    }

    span {
      font-weight: bold;
      line-height: 14px;
    }
  }
}

.chart-title {
  margin-bottom: 15px;

  h4.card-title {
    padding-left: 15px;
  }

  h4.line-chart {
    padding-left: 30px;
  }
}

@media only screen and (max-device-width: 1024px) {
  .mb-tablet-4 {
    margin-bottom: 2rem;
  }
  h4.line-chart.mb-0 {
    padding-right: 1px;
  }
}
</style>
<template>
  <div class="wrapper">
    <div class="header">
      <h4>Biển động nhân sự theo tháng</h4>
    </div>
    <div class="select-group__wrapper">
      <div class="select-group__left">
        <div class="time-content">Từ</div>
        <div class="month-picker__wrapper">
          <a-month-picker
            placeholder="YYYY-MM"
            size="large"
            @change="onChangeFrom"
            :disabled-date="disabledDate"
            v-model="startMonth"
            :class="'month-picker__input'"
          >
            <template slot="suffixIcon">
              <img src="../../assets/img/calendar.svg" alt="" />
            </template>
          </a-month-picker>
        </div>
      </div>
      <div class="select-group__right">
        <div class="time-content">Đến</div>
        <div class="month-picker__wrapper">
          <a-month-picker
            placeholder="YYYY-MM"
            size="large"
            @change="onChange"
            v-model="endMonth"
            :disabled-date="disabledEndDate"
            :class="'month-picker__input'"
          >
            <template slot="suffixIcon">
              <img src="../../assets/img/calendar.svg" alt="" />
            </template>
          </a-month-picker>
        </div>
      </div>
    </div>
    <div>
      <v-chart class="chart" :option="option" autoresize />
    </div>
    <div class="bottom">
      <!-- <img src="img/icons/note.svg" alt="" />
      <span>Thâm niên tính từ thời điểm tham gia công ty</span> -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { use } from "echarts/core";
import {
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { BarChart, LineChart, PictorialBarChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import VChart from "vue-echarts";
use([
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  LineChart,
  CanvasRenderer,
  UniversalTransition,
  PictorialBarChart,
]);

export default {
  metaInfo() {
    return {
      title: "Dashboard",
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    VChart,
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          textStyle: {
            fontFamily:
              "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
          },
        },
        grid: {
          show: false,
          top: "9%",
          left: "4%",
          right: "4%",
          bottom: "1%",
          containLabel: true,
        },
        legend: {
          data: ["Nghỉ", "Nhân sự mới", "Nhân sự cuối kì", "Tỷ lệ"],
          width: "60%",
          itemHeight: 16,
          itemWidth: 16,
          textStyle: {
            fontFamily:
              "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
          },
          selectedMode: false,
        },
        xAxis: [
          {
            type: "category",
            data: [],

            textStyle: {
              color: "#4381E2",
            },
            // axisPointer: {
            //   type: "shadow",
            // },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#303C54",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#D8D8D8",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "Số lượng\n(người)",
            min: 0,
            max: 250,
            interval: 25,
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#8F9194",
              },
            },
            splitLine: {
              lineStyle: {
                type: [5, 10],
                dashOffset: 5,
              },
            },
            nameTextStyle: {
              color: "#8F9194",
              lineHeight: 20,
            },
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#D8D8D8",
              },
            },
          },
          {
            type: "value",
            name: "Tỷ lệ",
            min: 0,
            max: 10,
            interval: 1,
            axisLabel: {
              formatter: "{value} %",
              textStyle: {
                color: "#8F9194",
              },
            },
            splitLine: {
              // show: false,
              lineStyle: {
                type: [5, 10],
              },
            },
            nameTextStyle: {
              color: "#8F9194",
              lineHeight: 50,
            },
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#D8D8D8",
              },
            },
          },
        ],
        series: [
          {
            name: "Nghỉ",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            data: [],
            label: {
              normal: {
                show: true,
                position: "top",
                fontWeight: "bold",
                fontFamily:
                  "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
              },
            },
            itemStyle: {
              color: "#FA8072",
            },
          },
          {
            name: "Nhân sự mới",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            data: [],
            // label: {
            //   normal: {
            //     show: true,
            //     position: "top",
            //     fontWeight: "bold",
            //     fontFamily:
            //       "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            //   },
            // },
            itemStyle: {
              color: "#49D278",
            },
          },
          {
            name: "Nhân sự cuối kì",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            data: [],
            itemStyle: {
              color: "#0F52BA",
            },
            label: {
              normal: {
                show: true,
                position: "top",
                fontWeight: "bold",
                fontFamily:
                  "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
              },
            },
            barGap: "0%",
          },
          {
            name: "Tỷ lệ",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            colorBy: "series",
            symbol: "circle",
            symbolSize: 10,
            symbolKeepAspect: true,
            lineStyle: {
              width: 3,
            },
            itemStyle: {
              color: "#EBAB71",
            },
            data: [],
          },
          {
            type: "pictorialBar",
            symbolSize: [0, 0],
            tooltip: {
              show: false,
            },
            symbolPosition: "end",
            label: {
              show: true,
              position: "top",
              // fontSize: 14,
              fontWeight: "bold",
              color: "#303C54",
              fontFamily:
                "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            },
            z: 10,
            data: [],
          },
        ],
      },
      searchOption: {
        dateStart: moment().startOf("year").format("YYYY-MM"),
        dateEnd: moment().format("YYYY-MM"),
      },
      endMonth: moment().format("YYYY-MM"),
      startMonth: moment().startOf("year").format("YYYY-MM"),
    };
  },
  async created() {
    await this.getEmployeeSeniority();
  },

  watch: {
    startMonth() {
      this.disabledEndDate();
    },

    endMonth() {
      this.disabledDate();
    },
  },

  computed: {
    ...mapGetters({
      employeeSeniority: "dashboard/employeeSeniority",
    }),
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),

    async getEmployeeSeniority() {
      this.setLoading(true);
      try {
        await this.$store.dispatch("dashboard/getEmployeeesSeniority", {
          params: this.searchOption,
        });
        this.spliceArr();
        if (Object.keys(this.employeeSeniority).length > 1) {
          const employeeSeniorityMerge = Object.values(
            this.employeeSeniority
          ).reduce((r, c) => Object.assign(r, c), {});

          const employeeSeniorityMergeValue = Object.values(
            employeeSeniorityMerge
          )
            .sort(function (a, b) {
              return moment(b.month) - moment(a.month);
            })
            .reverse();

          this.option.yAxis[0].max =
            Math.ceil(
              employeeSeniorityMergeValue.reduce((before, after) =>
                before.end > after.end ? before : after
              ).end / 50
            ) *
              50 +
            50;
          this.option.yAxis[1].max = this.option.yAxis[0].max / 25;

          employeeSeniorityMergeValue.forEach((item) => {
            this.option.xAxis[0].data.push(
              "T" + moment(item.month).format("M")
            );
            this.option.series[0].data.push(item.leave);
            this.option.series[1].data.push(item.new);
            this.option.series[2].data.push(item.end);
            this.option.series[3].data.push(
              Math.round((item.leave / ((item.begin + item.end) / 2)) * 100)
            );
            this.option.series[4].data.push(item.new);
          });
        } else {
          Object.values(this.employeeSeniority).forEach((item) => {
            this.option.yAxis[0].max =
              Math.ceil(
                Object.values(item).reduce((before, after) =>
                  before.end > after.end ? before : after
                ).end / 50
              ) *
                50 +
              50;
            this.option.yAxis[1].max = this.option.yAxis[0].max / 25;

            const sortData = Object.keys(item).sort(function (a, b) {
              return a - b;
            });

            sortData.forEach((data) => {
              this.option.xAxis[0].data.push(
                "T" + moment(item[data].month).format("M")
              );
              this.option.series[0].data.push(item[data].leave);
              this.option.series[1].data.push(item[data].new);
              this.option.series[2].data.push(item[data].end);
              this.option.series[3].data.push(
                Math.round(
                  (item[data].leave /
                    ((item[data].begin + item[data].end) / 2)) *
                    100
                )
              );
              this.option.series[4].data.push(item[data].new);
            });
          });
        }

        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    spliceArr() {
      this.option.xAxis[0].data.splice(0, this.option.xAxis[0].data.length);
      this.option.series[0].data.splice(0, this.option.series[0].data.length);
      this.option.series[1].data.splice(0, this.option.series[1].data.length);
      this.option.series[2].data.splice(0, this.option.series[2].data.length);
      this.option.series[3].data.splice(0, this.option.series[3].data.length);
      this.option.series[4].data.splice(0, this.option.series[4].data.length);
    },

    disabledDate(current) {
      let monthStart = moment("2018-07").startOf("day");
      let monthEnd = moment().endOf("day");

      if (this.endMonth) {
        monthEnd = moment(this.endMonth).endOf("day");
        if (
          moment("2018-07").isAfter(moment(this.endMonth).subtract(12, "month"))
        ) {
          monthStart = moment("2018-07").startOf("day");
        } else {
          monthStart = moment(this.endMonth)
            .subtract(12, "month")
            .startOf("day");
        }
      }

      return !(monthStart.isBefore(current) && monthEnd.isAfter(current));
    },

    disabledEndDate(current) {
      let monthStart = moment("2018-07").startOf("day");
      let monthEnd = moment().endOf("day");

      if (this.startMonth) {
        monthStart = moment(this.startMonth).subtract(1, "month").endOf("day");
        if (
          moment(this.startMonth).endOf("year").isSame(moment().endOf("year"))
        ) {
          monthEnd = moment();
        } else {
          monthEnd = moment(this.startMonth).add(12, "month").endOf("day");
        }
      }
      return !(
        monthStart.isSameOrBefore(current) && monthEnd.isSameOrAfter(current)
      );
    },

    async onChangeFrom() {
      if (!this.startMonth) {
        return;
      }
      if (!this.endMonth) {
        if (
          moment(this.startMonth).endOf("year").isSame(moment().endOf("year"))
        ) {
          this.searchOption = {
            dateStart: moment(this.startMonth).format("YYYY-MM"),
            dateEnd: moment().format("YYYY-MM"),
          };
        } else {
          if (moment(this.startMonth).add(12, "month").isAfter(moment())) {
            this.searchOption = {
              dateStart: moment(this.startMonth).format("YYYY-MM"),
              dateEnd: moment().format("YYYY-MM"),
            };
          } else {
            this.searchOption = {
              dateStart: moment(this.startMonth).format("YYYY-MM"),
              dateEnd: moment(this.startMonth)
                .add(12, "month")
                .format("YYYY-MM"),
            };
          }
        }
      } else {
        this.searchOption = {
          dateStart: moment(this.startMonth).format("YYYY-MM"),
          dateEnd: moment(this.endMonth).format("YYYY-MM"),
        };
      }

      await this.getEmployeeSeniority();
    },

    async onChange() {
      if (!this.endMonth) {
        return;
      }
      if (!this.startMonth) {
        if (
          moment(this.endMonth).endOf("year").isSame(moment().endOf("year"))
        ) {
          this.searchOption = {
            dateStart: moment().startOf("year").format("YYYY-MM"),
            dateEnd: moment(this.endMonth).format("YYYY-MM"),
          };
        } else {
          if (
            moment("2018-07").isAfter(
              moment(this.endMonth).subtract(12, "month")
            )
          ) {
            this.searchOption = {
              dateStart: moment("2018-07").format("YYYY-MM"),
              dateEnd: moment(this.endMonth).format("YYYY-MM"),
            };
          } else {
            this.searchOption = {
              dateStart: moment(this.endMonth)
                .subtract(12, "month")
                .format("YYYY-MM"),
              dateEnd: moment(this.endMonth).format("YYYY-MM"),
            };
          }
        }
      } else {
        this.searchOption = {
          dateStart: moment(this.startMonth).format("YYYY-MM"),
          dateEnd: moment(this.endMonth).format("YYYY-MM"),
        };
      }
      await this.getEmployeeSeniority();
    },
  },
};
</script>
